// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * API endpoint for deleting asset ownership information.
 * Provides functionality to record ownership transfers, including
 * sale prices and transfer dates.
 */
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes the ownership of an asset within a specific segment.
 *
 * @param {string} key - The key that uniquely identifies the asset for which ownership needs to be deleted.
 * @param {string} eventKey - The ID of the segment associated with the asset ownership to be deleted.
 * @return {Promise<Object>} A promise that resolves to a parsed success response indicating the deletion result.
 */
export async function deleteAssetOwnership(key: string, eventKey: string) {
  const path = `/v1/asset/${key}/ownership/${eventKey}`;
  const response = await api.delete(path);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteAssetOwnership',
    endpoint: path,
  });
}
